module.exports = __webpack_public_path__ + "static/premium-web-3915931809eb46634d8a924d5aa9d3d8.png";